import { useMutation } from "@tanstack/react-query";
import { useCustomValuesInvalidate } from "PFCore/hooks/queries/custom_fields/admin";
import { deleteActivity } from "PFCore/services/activities";
import { Id, MutationOptions } from "PFTypes";

import { useActivitiesInvalidate } from "../activities/use_activities_invalidate";
import { useRolesInvalidate } from "../roles/use_roles_invalidate";
import { useActivityInvalidate } from "./use_activity_invalidate";

type ActivityDeleteVariables = {
  activityId: Id;
  parentActivityId?: Id;
};

export const useActivityDelete = (options: MutationOptions<ActivityDeleteVariables> = {}) => {
  const { invalidate: invalidateCustomValues } = useCustomValuesInvalidate();
  const { invalidateByCollection } = useActivitiesInvalidate();
  const { invalidateRoles, invalidateAuditRoles } = useRolesInvalidate();
  const { invalidate: invalidateActivity } = useActivityInvalidate();

  return useMutation<void, unknown, ActivityDeleteVariables>({
    mutationFn: ({ activityId }) => deleteActivity(activityId),
    ...options,
    onSuccess: (...args) => {
      const { parentActivityId } = args[1];
      invalidateCustomValues();
      invalidateByCollection();
      invalidateRoles();
      invalidateAuditRoles();
      parentActivityId && invalidateActivity([parentActivityId]);

      options.onSuccess?.(...args);
    }
  });
};
